module.exports = __webpack_public_path__ + "static/media/list-white.f2e15db9.svg";